import { useEffect, useRef } from 'react'

type UseUploadDocumentsAutoAdvanceArgs = {
  isError: boolean
  isLoading: boolean
  onNext: (options?: { skipUploadStep?: boolean }) => void
  visibleDocumentsCount: number
}

export function useUploadDocumentsAutoAdvance({
  isError,
  isLoading,
  onNext,
  visibleDocumentsCount
}: UseUploadDocumentsAutoAdvanceArgs) {
  const hasAutoAdvancedRef = useRef(false)

  useEffect(() => {
    if (hasAutoAdvancedRef.current) {
      return
    }

    if (isLoading || isError) {
      return
    }

    if (visibleDocumentsCount > 0) {
      return
    }

    hasAutoAdvancedRef.current = true
    onNext({ skipUploadStep: true })
  }, [isError, isLoading, onNext, visibleDocumentsCount])
}
